import type { SelectedWebsites } from "./types";

export const MAX_ITEMS_SELECTED = 10;
export const MAX_INDUSTRY_SELECTED = 1;

export const selectedDomainItemsInitialState: SelectedWebsites = {
    ids: {},
    size: 0,
};

/** Metric type for the Market Shares bar chart widget (AVERAGE chart type). */
export const MARKET_SHARES_METRIC_TYPE = "MarketShares" as const;
/** Metric type for the Market Shares graph widget (OVERTIME chart type). */
export const MARKET_SHARES_GRAPH_METRIC_TYPE = "MarketSharesGraph" as const;

export const MARKET_ANALISIS_AUTOCOMPLITE = {
    DEBOUNCE: 250,
    MAX_ITEMS_TO_SELECT: 1,
    MAX_RESULTS: 10,
    Z_INDEX: 9,
};

export const websitesDropdownPopupHeight = 250;

export const IDUSTRY_PLACEHOLDER_SIZE = {
    width: 557,
    heigth: 39,
};

export const TRAFFIC_SOURCE = {
    DESKTOP: "Desktop",
    TOTAL: "Total",
};

export const defaultWidgetType = { type: MARKET_SHARES_METRIC_TYPE, id: "BarChart" };
